import { useRef } from "react";
import Select from "react-select";
import useReportForm from "./hook/useReportForm";
import useReportExport from "./hook/useReportExport";
import { useDispatch, useSelector } from "react-redux";
import isTenantUser from "../../CustomHook/tenantUser";


export default function ReportIndex() {
    const selectRef = useRef();
    const dispatch = useDispatch();
    const { user: profileUser } = useSelector((state) => state.profileReducer);
    const { user: authUser } = useSelector((state) => state.authReducer);
    const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);
    const {
        form,
        options,
        loading,
        handleClusterChange,
        handleZoneChange,
        handleSiteChange,
        handleSiteSearch,
        handleAlarmsChange,
        resetForm,
        setForm,
    } = useReportForm(dispatch);

    const { progress, exportLoading, exportReport } = useReportExport();

    return (
        <div className="container-fluid mb-2">
            <div className="row g-1 mt-3">
                <div className="container1 mt-5">
                    <div className="card">
                        <div className="card-body">
                            <form>
                                <div className="row">
                                    {/* Report Type */}
                                    <div className="form-group col-md-12 mb-2">
                                        <label>Report Type</label>
                                        <Select
                                            ref={selectRef}
                                            value={options.report_types.find((r) => r.value === form.report_type)}
                                            onChange={(e) => setForm((prev) => ({ ...prev, report_type: e?.value }))}
                                            options={options.report_types}
                                            isClearable
                                            placeholder="All"
                                        />
                                    </div>

                                    {/* Cluster / Zone / Site */}
                                    <div className="form-group col-md-6 mb-2">
                                        <label>Cluster</label>
                                        <Select
                                            value={options.clusters.find((c) => c.value === form.cluster)}
                                            onChange={handleClusterChange}
                                            options={options.clusters}
                                            isClearable
                                        />
                                    </div>
                                    <div className="form-group col-md-6 mb-2">
                                        <label>Zone</label>
                                        <Select
                                            value={options.zones.find((z) => z.value === form.zone)}
                                            onChange={handleZoneChange}
                                            options={options.zones}
                                            isClearable
                                        />
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <label>SITE ID</label>
                                        <Select
                                            value={
                                                options.sites.find((s) => String(s.value) === String(form.site))
                                                || (form.site ? { value: form.site, label: form.site } : null)
                                            }
                                            onChange={handleSiteChange}
                                            onInputChange={handleSiteSearch}
                                            options={options.sites}
                                            isClearable
                                            filterOption={() => true}
                                        />
                                    </div>

                                    {/* Alarms */}
                                    {form.report_type === 1 && (
                                        <div className="form-group col-md-12 mb-2">
                                            <label>RMS Alarm</label>
                                            <Select
                                                isMulti
                                                value={form.rms_alarm}
                                                onChange={(e) => handleAlarmsChange("rms_alarm", e)}
                                                options={options.rms_alarms}
                                            />
                                        </div>
                                    )}
                                    {form.report_type === 22 && (
                                        <div className="form-group col-md-12 mb-2">
                                            <label>ACM Alarm</label>
                                            <Select
                                                isMulti
                                                value={form.acs_alarm}
                                                onChange={(e) => handleAlarmsChange("acs_alarm", e)}
                                                options={options.acs_alarms}
                                            />
                                        </div>
                                    )}

                                    {/* Date */}
                                    <div className="form-group col-md-12 mb-2">
                                        <label>Date</label>
                                        <div className="input-group mb-1">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={form.start_date}
                                                onChange={(e) => setForm((prev) => ({ ...prev, start_date: e.target.value }))}
                                            />
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={form.end_date}
                                                onChange={(e) => setForm((prev) => ({ ...prev, end_date: e.target.value }))}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-md-12 mb-1">
                                        {!tenantUser && (
                                            <>
                                                <label>Tenant</label>
                                                <Select
                                                    value={options.tenants.find((t) => t.value === form.tenant)}
                                                    onChange={(e) => setForm((prev) => ({ ...prev, tenant: e?.value }))}
                                                    options={options.tenants}
                                                    isClearable
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="mt-2">
                                    <button type="button" className="btn btn-info ms-2" onClick={() => exportLoading?null:exportReport(form)}>
                                        {exportLoading ? "Exporting..." : "Export"} {exportLoading ? (
                                            <span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true"></span>
                                        ) : (
                                            <span></span>
                                        )}
                                    </button>
                                    <button type="button" className="btn btn-secondary ms-2" onClick={resetForm}>
                                        Reset
                                    </button>
                                </div>

                                {/* Progress */}
                                {exportLoading && (
                                    <div className="progress mt-2">
                                                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">{progress}%</div>
                                            </div>
                                )}

                                
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
